import {
  FIELD_VALIDATORS,
  SIGN_UP_FIELDS,
} from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/utils';
import {
  FieldObjectType,
  INITIAL_SIGNUP_DATA,
  SignUpContextType,
} from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context/utils';
import { isString } from 'lodash';
import {
  ChangeEvent,
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';

const SignUpContext = createContext<SignUpContextType>({} as SignUpContextType);

type Props = {
  children: ReactNode;
};

export const SignUpProvider = ({ children }: Props) => {
  const [fields, setFields] = useState(INITIAL_SIGNUP_DATA);

  const fieldChangeHandler =
    (field: SIGN_UP_FIELDS) =>
    (event: ChangeEvent<HTMLInputElement> | string) => {
      const value = isString(event) ? event : event.target.value;
      const { isValid, errorMessage } = FIELD_VALIDATORS[field](value);
      setFields({
        ...fields,
        [field]: {
          value,
          isValid,
          errorMessage,
        },
      });
    };

  const checkFormValid = (filterFields: SIGN_UP_FIELDS[]) => {
    return filterFields.every((key) => fields[key] && fields[key].isValid);
  };

  const isFormValid = useMemo(() => {
    return checkFormValid(Object.keys(fields) as SIGN_UP_FIELDS[]);
  }, [fields]);

  return (
    <SignUpContext.Provider
      value={{
        phoneNumber: fields.phoneNumber.value,
        email: fields.email.value,
        fullName: fields.fullName.value,
        dateOfBirth: fields.dateOfBirth.value,
        dateOfBirthErrorMessage: fields.dateOfBirth.errorMessage,
        fieldChangeHandler,
        isFormValid,
        checkFormValid,
      }}
    >
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUp = () => {
  return useContext(SignUpContext);
};
